import { poshiq_diet_plan } from "../../js/path";
import _ from "lodash";

export default {
  data() {
    return {
      pageNo: null,
      table_header: [],
      diet_plan_id: null,
      loadingId: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Patient name",
        },
        {
          key: "patient_number",
          label: "Patient Number",
        },
        {
          key: "order_id",
          label: "Order Id",
        },
        {
          key: "payment_date",
          label: "Payment Date",
        },
        {
          key: "status",
          label: "Diet Plan Status",
        },
        {
          key: "gen_plan_status",
          label: "Action",
        },
        {
          key: "edit",
        },
        {
          key: "is_approved",
          label: "Approved Status",
        },
      ],
      oldForm: {},
      form: {
        html: "",
      },
      params: "",
      filter: null,
      filterOn: [],
      tableData: [],
      sortBy: "id",
      sortDesc: true,
      key: 0,
      activeTab: "all",
      currentPage: 1,
      firstLoad: false,
      isEditingPreview: false,
      selectedFiles: [],
      imageFiles: [],
      pdfFiles: [],
      chatList: [],
    };
  },
  methods: {
    // limitMealsSelection(qa) {

    //     let extra = qa.question.extra;

    //     if (extra && typeof extra === 'string') {
    //         extra = JSON.parse(extra);
    //     }

    //     // Apply limit only for meals question
    //     if (extra?.type !== 'meals') {
    //         return;
    //     }

    //     if (qa.answer.length > 2) {

    //         qa.answer.pop();

    //         this.$bvToast.toast(
    //             'You can select only 2 meals.',
    //             {
    //                 title: 'Warning',
    //                 variant: 'warning',
    //                 solid: true
    //             }
    //         );
    //     }
    // },
    limitMealsSelection(qa) {

        let extra = qa.question.extra;

        if (extra && typeof extra === 'string') {
            extra = JSON.parse(extra);
        }

        // Meals logic
        if (extra?.type === 'meals') {

            if (qa.answer.length > 2) {

                qa.answer.pop();

                this.$bvToast.toast(
                    'You can select only 2 meals.',
                    {
                        title: 'Warning',
                        variant: 'warning',
                        solid: true
                    }
                );
            }

            return;
        }

        // Allergies logic
        if (extra?.type === 'allergies') {

            if (!qa.answer || qa.answer.length === 0) {
                return;
            }

            const hasNone = qa.answer.includes('None');

            if (hasNone && qa.answer.length > 1) {

                // If None is the last selected item, keep only None
                if (qa.answer[qa.answer.length - 1] === 'None') {

                    qa.answer = ['None'];

                } else {

                    // User selected another option while None was already selected
                    qa.answer = qa.answer.filter(item => item !== 'None');

                }

            }

        }

    },
    search(event) {
      if (this.filter.length > 1) {
        if (event.keyCode == 13) {
          this.fetchData(this.activeTab);
        }
      } else if (this.filter.length == 0) this.fetchData(this.activeTab);
    },
    searchFor() {
      if (this.filter.length > 0) {
        this.fetchData(this.activeTab);
      } else {
        this.fetchData(this.activeTab);
      }
    },
    filterPage() {
      if (this.pageNo.length > 0) {
        this.params = `&page=${this.pageNo}`;
        this.fetchData(this.activeTab);
        this.currentPage = this.pageNo;
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async fetchData(txt) {
      let url = null;
      if (txt == "generated") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            poshiq_diet_plan.diet_planUrl +
            "?filter=" +
            txt +
            "&search=" +
            this.filter;
        } else {
          url = poshiq_diet_plan.diet_planUrl + "?filter=" + txt;
        }
      } else if (txt == "not-generated") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            poshiq_diet_plan.diet_planUrl +
            "?filter=" +
            txt +
            "&search=" +
            this.filter;
        } else {
          url = poshiq_diet_plan.diet_planUrl + "?filter=" + txt;
        }
      } else if (txt == "all") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            poshiq_diet_plan.diet_planUrl +
            "?filter=" +
            txt +
            "&search=" +
            this.filter;
        } else {
          url = poshiq_diet_plan.diet_planUrl + "?filter=" + txt;
        }
      }
      url += this.params;
      this.$store.commit("loader/updateStatus", true);
      try {
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          this.tableData = responseData;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
      this.key += 1;
    },

    async fetchDietPlan(id) {
      this.$store.commit("loader/updateStatus", true);
      let url = poshiq_diet_plan.diet_planUrl + "/" + id;
      const data = await this.getRequest(url);
      if (data.status) {
        const responseData = data.response;
        this.diet_plan_id = responseData.id;

        if (responseData.html != "" && responseData.html != null) {
          this.form.html = responseData.html;
        }

        this.edit.html = responseData.html;

        this.oldForm = _.clone(this.form);
      }

      this.$store.commit("loader/updateStatus", false);
    },
    cleanHTML(html) {
      return html
        .replace(/<div><br><\/div>/g, "")
        .replace(/<div>\s*<\/div>/g, "")
        .replace(/<p><br><\/p>/g, "")
        .replace(/&nbsp;/g, " ");
    },

    onEdit() {
      let cleaned = this.cleanHTML(this.$refs.editor.innerHTML);
      this.form.html = cleaned;
    },

    onTextareaEdit() {
      if (!this.isEditingPreview) {
        this.$refs.editor.innerHTML = this.form.html;
      }
    },

    async updateStatus(transaction) {
      console.log("Updating transaction:", transaction);

      this.loadingId = transaction.id;
      try {
        if (!transaction.id) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Transaction ID is required.",
          });
          this.loadingId = null;
          return;
        }

        const selectedLanguage =
          transaction.chat?.[0]?.question?.language || "english";

        // const dataArray = transaction.chat.map((item) => ({
        //   question: item.question?.question || "",
        //   answer: item.answer || "",
        // }));

        const dataArray = transaction.chat
          .map((item) => {
            let question = item.question?.question?.trim() || "";
            let answer = item.answer;

            // If answer is JSON string: "[\"Egg\"]"
            if (typeof answer === "string") {
              try {
                const parsed = JSON.parse(answer);
                if (Array.isArray(parsed)) {
                  answer = parsed.join(", ");
                }
              } catch (e) {
                answer = answer.trim();
              }
            }

            // If answer is actual array
            if (Array.isArray(answer)) {
              answer = answer.join(", ");
            }

            answer = (answer || "").trim();

            return { question, answer };
          })
          .filter((item) => item.question !== "" || item.answer !== "");

        const hasValidData = dataArray.some(
          (item) => item.question.trim() !== "" && item.answer.trim() !== ""
        );

        if (!hasValidData) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title:
              "Please provide at least one valid question and answer before generating the diet plan.",
          });
          this.loadingId = null;
          return; // 🚫 stop execution
        }

        const medicalReports = transaction.chat
          .flatMap((item) => item.file || [])
          .map((file) => file.trim())
          .filter(Boolean);

        const payload = {
          data: dataArray,
          medical_reports: medicalReports,
          language: selectedLanguage,
          transaction_id: transaction.id,
          name: transaction.patient_name?.trim() || 'User'
        };

        const url = poshiq_diet_plan.updateStatus + "/" + transaction.id;
        const data = await this.postRequest(url, payload);

        if (data.status) {
          const index = this.tableData.data.findIndex(
            (e) => e.id === transaction.id
          );

          // ✅ Update both status and file_name (if returned)
          this.tableData.data[index].status = "created";
          this.tableData.data[index].file_name =
            data.response?.pdf_url || this.tableData.data[index].file_name;
          this.tableData.data[index].pdf_url =
            data.response?.pdf_url ?? this.tableData.data[index].file_name;

          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      } finally {
        this.loadingId = null;
      }
    },

    async generatePdf(record) {
      console.log("generating PDF:", record.id);

      try {
        const payload = {
          html: record.html,
          transaction_id: record.id,
        };

        console.log("PAYLOAD:", payload);

        const url = poshiq_diet_plan.generatePdf;
        console.log("PDF URL:", url);

        const response = await this.postRequest(url, payload);
        console.log("Response wow:", response);

        if (response.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: response.message,
          });
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      } finally {
        this.loadingId = null;
      }
    },

    async submitData() {
      try {
        this.submitted = true;
        this.$v.$touch();

        // default loader before API submit
        this.$store.commit("loader/updateStatus", {
          status: true,
          message: "Submitting data...",
        });

        let url = poshiq_diet_plan.diet_planUrl + "/" + this.diet_plan_id;

        let dataAppend = new FormData();
        dataAppend.append("_method", "PATCH");
        if (this.form.html) dataAppend.append("html", this.form.html);

        const data = await this.postRequest(url, dataAppend);

        if (data.status) {
          // 🔥 Show loader while generating new PDF
          this.$store.commit("loader/updateStatus", {
            status: true,
            message: "Generating new plan...",
          });

          await this.generatePdf(data.response);

          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });

          this.$router.push("/poshiq-diet-plan");
        }
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }

      this.$store.commit("loader/updateStatus", false);
    },

    async fetchDiet_plan(id) {
      this.$store.commit("toast/updateStatus", true);
      try {
        let url = poshiq_diet_plan.diet_planUrl + "/" + id;
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          this.diet_plan_id = responseData.id;
        }
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Fetching error!",
        });
      }
      this.$store.commit("toast/updateStatus", false);
    },
    tabActive() {
      if (!this.can("edit-poshiq-diet-plan")) {
        let index = this.fields.findIndex((item) => item.key == "edit");
        if (index !== -1) {
          this.fields.splice(index, 1);
          let table_index = this.table_header.findIndex(
            (item) => item == "edit"
          );
          this.table_header.splice(table_index, 1);
        }
      } else {
        if (!this.table_header.includes("edit")) {
          this.table_header.push("edit");
          // Put "edit" back just before the approved-status column instead of
          // at a hardcoded index, so adding columns above doesn't clobber one.
          let approved_index = this.fields.findIndex(
            (item) => item.key == "is_approved"
          );
          this.fields.splice(
            approved_index == -1 ? this.fields.length : approved_index,
            0,
            { key: "edit" }
          );
        }
      }
    },
    // async updateApproveStatus(id) {
    //   console.log(id, "id");
      
    //   try {
    //     let index = this.tableData.data.findIndex((e) => e.id === id);
    //     const url = poshiq_diet_plan.updateApproveStatus + "/" + id;
    //     const data = await this.postRequest(url, {
    //       is_approved: !this.tableData.data[index].is_approved,
    //     });
    //     if (data.status) {
    //       const responseData = data.response;
    //       this.tableData.data[index] = responseData;
    //       this.$store.commit("toast/updateStatus", {
    //         status: true,
    //         icon: "success",
    //         title: data.message,
    //       });
    //     }
    //     this.key += 1;
    //   } catch (err) {
    //     this.$store.commit("toast/updateStatus", {
    //       status: true,
    //       icon: "error",
    //       title: err.data ? err.data.message : "Please try again!",
    //     });
    //   }
    // }, 
    async updateApproveStatus(id) {
      try {
        let index = this.tableData.data.findIndex((e) => e.id === id);
        const url = poshiq_diet_plan.updateApproveStatus + "/" + id;
    
        const newStatus =
          this.tableData.data[index].is_approved == 1 ? 0 : 1;
    
        const data = await this.postRequest(url, {
          is_approved: newStatus,
        });
    
        if (data.status) {
          this.tableData.data[index] = data.response;
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
    
        this.key += 1;
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
    },
    // Fetch a single transaction (including its chat) on demand.
    // The list response no longer carries `chat`, so modal / generate
    // actions load the full record for just the clicked row.
    async fetchTransaction(id) {
      this.$store.commit("loader/updateStatus", true);
      try {
        const data = await this.getRequest(poshiq_diet_plan.diet_planUrl + "/" + id);
        return data.status ? data.response : null;
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
        return null;
      } finally {
        this.$store.commit("loader/updateStatus", false);
      }
    },

    async generatePlanById(row) {
      this.loadingId = row.id;
      const full = await this.fetchTransaction(row.id);
      if (!full) {
        this.loadingId = null;
        return;
      }
      await this.updateStatus(full);
    },

    async openDocumentsById(id) {
      const full = await this.fetchTransaction(id);
      if (!full) return;
      this.openModal(full.chat || []);
    },

    async openQnAById(id) {
      const full = await this.fetchTransaction(id);
      if (!full) return;
      this.openChatModal(full.chat || []);
    },

    async openEditAnswerById(id) {
      const full = await this.fetchTransaction(id);
      if (!full) return;
      this.openChatEditModal(full);
    },

    openModal(itemArray) {

      const fileItem = itemArray.find(i => i.file && i.file.length > 0);

      if (!fileItem) {
        this.imageFiles = [];
        this.pdfFiles = [];
        this.selectedFiles = [];
        this.$bvModal.show("document-modal");
        return;
      }

      // file is an array of URL strings
      this.selectedFiles = fileItem.file;
      this.imageFiles = this.selectedFiles.filter(f => this.isImage(f));
      this.pdfFiles = this.selectedFiles.filter(f => this.isPdf(f));

      this.$bvModal.show("document-modal");
    },

    openChatModal(itemArray) {
      this.chatList = itemArray;
      this.$bvModal.show("chat-modal");
    },

     addFile(file, qa) {

          if (!file) return;

          qa.file.push(file);
          qa.selectedFile = null;
      },

      removeFile(index, qa) {

          if (!qa.file || !Array.isArray(qa.file)) {
              qa.file = [];
              return;
          }

          qa.file.splice(index, 1);

          if (qa.file.length === 0) {
              qa.selectedFile = null;
          }

      },

    openChatEditModal(data) {
        this.patient_id = data.patient_id;
        this.selectedTransaction = data;
        this.chatList = data.chat.map(item => {


            let answer = item.answer;

            if (item.question.type === 'multicheck') {
                answer = answer ? JSON.parse(answer) : [];
            }

            if (
                item.question.type === 'option' &&
                item.question.extra
            ) {

                let extra = item.question.extra;

                if (typeof extra === 'string') {
                    extra = JSON.parse(extra);
                }

                if (extra.type === 'meals') {
                    answer = answer ? JSON.parse(answer) : [];
                }
            }

            return {
                ...item,
                answer,

                // UI properties
                editing: false,
                loading: false,
                saving: false,
                error: null,
                selectedFile: null,
                file: item.file || [],
                highlight: false
            };
        });

        this.$bvModal.show('chat-modal-edit');
    },

    parseOptions(options) {

        if (!options) {
            return [];
        }

        // If options is a JSON string
        if (typeof options === 'string') {
            options = JSON.parse(options);
        }

        return options.map(item => ({
            text: item.title,
            value: item.title
        }));

    },

    parseMultiOptions(options) {
      if (!options) return [];

      return JSON.parse(options).map(item => ({
        text: item.title,
        value: item.title
      }));
    },

    async updateAnswer(qa) {

        qa.saving = true;

        try {

            const url = poshiq_diet_plan.updateAnswerUrl;

            if (qa.question.type === 'file') {

                const formData = new FormData();

                formData.append('member_id', this.patient_id);
                formData.append('question_id', qa.question_id);

                if (qa.file && qa.file.length) {

                    qa.file.forEach(file => {
                        formData.append('file[]', file);
                    });

                } else if (qa.answer === 'skip') {

                    formData.append('answer', 'skip');

                }

                await this.postRequest(url, formData);

            // } else {

            //     let answer = qa.answer;

            //     if (qa.question.type === 'multicheck') {
            //         answer = JSON.stringify(answer);
            //     }

            //     const payload = {
            //         member_id: this.patient_id,
            //         question_id: qa.question_id,
            //         answer
            //     };

            //     await this.postRequest(url, payload);
            // }

            } else {

                let answer = qa.answer;

                if (qa.question.type === 'multicheck') {
                    answer = JSON.stringify(answer);
                }

                // Parse extra
                let extra = qa.question.extra;

                if (extra && typeof extra === 'string') {
                    extra = JSON.parse(extra);
                }

                // Save current answer
                const payload = {
                    member_id: this.patient_id,
                    question_id: qa.question_id,
                    answer
                };

                console.log(url, payload);

                await this.postRequest(url, payload);

                // Calculate BMI if current question is weight or height
                if (
                    extra?.type === 'weight' ||
                    extra?.type === 'height'
                ) {

                    // Find weight question
                    const weightQuestion = this.chatList.find(item => {

                        let extra = item.question.extra;

                        if (extra && typeof extra === 'string') {
                            extra = JSON.parse(extra);
                        }

                        return extra?.type === 'weight';

                    });

                    // Find height question
                    const heightQuestion = this.chatList.find(item => {

                        let extra = item.question.extra;

                        if (extra && typeof extra === 'string') {
                            extra = JSON.parse(extra);
                        }

                        return extra?.type === 'height';

                    });

                    // Find BMI question
                    const bmiQuestion = this.chatList.find(
                        item => item.question.type === 'bmi'
                    );

                    if (
                        weightQuestion &&
                        heightQuestion &&
                        bmiQuestion
                    ) {

                        const weight = Number(weightQuestion.answer);
                        const height = Number(heightQuestion.answer);

                        if (
                            !isNaN(weight) &&
                            !isNaN(height) &&
                            weight > 0 &&
                            height > 0
                        ) {

                            const bmi = (
                                weight / Math.pow(height / 100, 2)
                            ).toFixed(2);

                            // Update UI
                            this.$set(bmiQuestion, 'answer', bmi);

                            // Save BMI answer
                            await this.postRequest(url, {
                                member_id: this.patient_id,
                                question_id: bmiQuestion.question_id,
                                answer: bmi
                            });

                            const originalBmiChat = this.selectedTransaction.chat.find(
                                item => item.question_id == bmiQuestion.question_id
                            );

                            if (originalBmiChat) {
                                originalBmiChat.answer = bmi;
                            }

                        }

                    }

                }

            }

            const originalChat = this.selectedTransaction.chat.find(
                item => item.question_id == qa.question_id
            );

            if (originalChat) {

                if (qa.question.type === 'multicheck') {
                    originalChat.answer = JSON.stringify(qa.answer);
                } else {
                    originalChat.answer = qa.answer;
                }

                originalChat.file = [...qa.file];
            }

            if (
                qa.question.type === 'option' &&
                qa.answer === '2'
            ) {

                this.$set(qa.question, 'type', 'multicheck');

                this.$set(
                    qa.question,
                    'option',
                    [
                        {
                            title: "Breakfast",
                            logo: ""
                        },
                        {
                            title: "Lunch",
                            logo: ""
                        },
                        {
                            title: "Dinner",
                            logo: ""
                        },
                        {
                            title: "Snacks",
                            logo: ""
                        }
                    ]
                );

                this.$set(qa, 'answer', []);

                // Keep same question in edit mode
                this.$set(qa, 'editing', true);

                qa.saving = false;
                return;
            }

             // Remove previous highlights
            this.chatList.forEach(item => {
                this.$set(item, 'highlight', false);
                this.$set(item, 'editing', false);
            });

            // Parse extra
            let extra = qa.question.extra;

            if (extra && typeof extra === 'string') {
                extra = JSON.parse(extra);
            }

            // Medication -> Upload question
            if (
                extra?.type === 'medication' &&
                qa.answer.toLowerCase() === 'yes'
            ) {

                const uploadQuestion = this.chatList.find(item => {

                    let itemExtra = item.question.extra;

                    if (itemExtra && typeof itemExtra === 'string') {
                        itemExtra = JSON.parse(itemExtra);
                    }

                    return itemExtra?.type === 'upload';

                });

                if (uploadQuestion) {

                    this.$set(uploadQuestion, 'highlight', true);
                    this.$set(uploadQuestion, 'editing', true);

                }
            }

            // Highlight question whose question_id = sub_id
            if (extra?.sub_id) {

                const targetQuestion = this.chatList.find(
                    item => item.question_id == extra.sub_id
                );

                if (targetQuestion) {

                  // Call nextQuestions API
                  const response = await this.getRequest(
                      `${poshiq_diet_plan.nextQuestionsUrl}?member_id=${this.patient_id}&question_id=${extra.sub_id}`
                  );

                  // Replace option with API response
                  this.$set(
                      targetQuestion.question,
                      'option',
                      response.response
                  );
                  this.$set(targetQuestion, 'answer', []);
                  this.$set(targetQuestion, 'highlight', true);
                  this.$set(targetQuestion, 'editing', true);
                }
            }

            qa.editing = false;

        } finally {

            qa.saving = false;

        }
    },

    formatAnswer(answer) {
      // If answer is null or empty return ''
      if (!answer) return '';
    
      // If answer is already an array
      if (Array.isArray(answer)) {
        return answer.join(", ");
      }
    
      // If answer is a JSON string array → parse it
      if (typeof answer === "string" && answer.startsWith("[") && answer.endsWith("]")) {
        try {
          const parsed = JSON.parse(answer); // Convert string to array
          if (Array.isArray(parsed)) {
            return parsed.join(", ");
          }
        } catch (e) {
          console.warn("JSON parse failed:", answer);
        }
      }
    
      // Otherwise return as string
      return answer;
    },    

     isImage(file) {

        if (file instanceof File) {
            return file.type.startsWith('image/');
        }

        return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
    },

    isPdf(file) {

        if (file instanceof File) {
            return file.type === 'application/pdf';
        }

        return /\.pdf$/i.test(file);
    },

    getFilePreview(file) {

        if (file instanceof File) {
            return URL.createObjectURL(file);
        }

        return file;
    },

    getFileName(file) {

        if (file instanceof File) {
            return file.name;
        }

        // return file.split('/').pop();
        return decodeURIComponent(
            file.substring(file.lastIndexOf('/') + 1)
        );
    },
    openFile(url) {
      window.open(url, "_blank");
    },
    async skipUpload(qa) {

        qa.answer = 'skip';

        // Remove all selected files
        this.$set(qa, 'file', []);
        this.$set(qa, 'newFiles', []);

        await this.updateAnswer(qa);

    }
  },
  watch: {
    currentPage: {
      handler: function (value) {
        if (typeof value != undefined) {
          this.params = `&page=${value}`;
          this.fetchData(this.activeTab);
          this.pageNo = this.currentPage;
        }
      },
    },
    "form.html"(newVal) {
      if (!this.firstLoad && newVal) {
        this.$refs.editor.innerHTML = newVal;
        this.firstLoad = true;
      }
    },
    activeTab(v) {
      if (v) this.tabActive();
    },
  },
  mounted() {
    if (this.$route.name == "edit-poshiq-diet-plan") {
      this.fetchDietPlan(this.$route.params.id);
    }
    this.tabActive();

    this.$refs.editor.innerHTML = this.form.html;
  },
  created() {
    this.fetchData(this.activeTab);
    this.fields.map((item) => {
      this.table_header.push(item.key);
    });
  },
};
